<template>
  <div class="proposal__wrap">
    <div class="section shadow filter__wrap">
      <div style="margin-bottom: 10px">
        <el-radio-group v-model="table.params.type" @change="handleTabs">
          <el-radio-button :label="1">待审核</el-radio-button>
          <el-radio-button :label="2">企业列表</el-radio-button>
          <el-radio-button :label="3">未充值</el-radio-button>
          <el-radio-button :label="4">审核失败</el-radio-button>
          <el-radio-button :label="5">下架企业</el-radio-button>
          <el-radio-button :label="6">待完善</el-radio-button>
        </el-radio-group>
      </div>
      <div class="flex">
        <el-form
          ref="elFormDom"
          inline
          :model="table.params"
          size="small"
          class="flex"
          @submit.native.prevent="handleSearch"
        >
          <template v-if="[2, 3, 5].includes(table.params.type)">
            <el-form-item label="激活日期" prop="date">
              <el-date-picker
                style="width: 250px"
                v-model="table.params.date"
                type="daterange"
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="激活状态" prop="is_earnest">
              <el-select
                @change="handleSearch"
                v-model="table.params.is_earnest"
                placeholder="请选择"
                clearable
              >
                <el-option label="已激活" :value="1"></el-option>
                <el-option label="未激活" :value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="是否白名单" prop="is_excellent">
              <el-select
                @change="handleSearch"
                v-model="table.params.is_excellent"
                placeholder="请选择"
                clearable
              >
                <el-option label="是" :value="1"></el-option>
                <el-option label="否" :value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="对接人" prop="contacter">
              <el-select
                v-model="table.params.contacter"
                filterable
                clearable
                placeholder="请选择"
              >
                <el-option
                  :label="item.name"
                  :value="item.id"
                  :key="item.id"
                  v-for="item in contacterOption"
                ></el-option>
              </el-select>
            </el-form-item>
          </template>
          <el-form-item label="" prop="keyword">
            <el-input
              @keyup.enter.native.prevent="handleSearch"
              clearable
              v-model="table.params.keyword"
              placeholder="请输入企业名称"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              icon="el-icon-search"
              @click="handleSearch"
              >查询
            </el-button>
            <el-button icon="el-icon-refresh-right" @click="reset"
              >重置</el-button
            >
          </el-form-item>
        </el-form>
      </div>
      <div style="margin-top: 10px">
        <el-button type="primary" size="mini" @click="dialogVisible = true"
          >导入企业
        </el-button>
        <el-button @click="downloadImportFile" size="mini"
          >下载企业导入样表</el-button
        >
        <el-button v-if="table.params.type == 2" @click="recruitmentCompany" size="mini"
          >参加招聘会</el-button
        >
      </div>
    </div>
    <!-- 表格 -->
    <div class="table__wrap">
      <!-- 1.待审核 -->
      <template v-if="this.table.params.type === 1">
        <VTable
          ref="tableDom"
          has-pagionation
          title=""
          addText="添加"
          :tableKey="table.params.type"
          :field="field0"
          :loading="table.loading"
          :data="table.data"
          :page="table.params.page"
          :pageSize="table.params.count"
          :total="table.total"
          :tree-props="{ children: 'children', hasChildren: 'has_child' }"
          :hasPagionation="true"
          :default-expand-all="true"
          :showOverflowTooltip="true"
          @handleSizeChange="handleSizeChange"
          @handleCurrentChange="handleCurrentChange"
        >
          <template v-slot:name="{ row }">
            <div>{{ row.name }}</div>
            <!--  芝麻企业信用认证 ali_certify_status 大于3时才显示图标 -->
            <div
              v-if="row.ali_certify_status > 3"
              style="display: flex; align-items: center"
            >
              <el-image
                style="width: 15px; height: 15px"
                fit="cover"
                :src="require('@/assets/img/zmxy.png')"
              ></el-image>
              <span style="font-size: 12px">芝麻企业信用认证</span>
            </div>
          </template>
          <template v-slot:device_type="{ row }">
            {{
              {
                1: "小程序",
                2: "ios",
                3: "安卓",
                4: "支付宝小程序",
                5: "支付宝lot设置",
                6: "web端",
              }[row.device_type] || ""
            }}
          </template>
          <template v-slot:action="{ row }">
            <el-button type="text" size="mini" @click="showDetail(row)"
              >审核</el-button
            >
          </template>
        </VTable>
      </template>
      <!-- 3.未充值 4.审核失败 -->
      <template
        v-if="this.table.params.type === 3 || this.table.params.type === 4"
      >
        <VTable
          ref="tableDom"
          has-pagionation
          title=""
          addText="添加"
          :tableKey="table.params.type"
          :field="field"
          :loading="table.loading"
          :data="table.data"
          :page="table.params.page"
          :pageSize="table.params.count"
          :total="table.total"
          :tree-props="{ children: 'children', hasChildren: 'has_child' }"
          :hasPagionation="true"
          :default-expand-all="true"
          :showOverflowTooltip="true"
          @handleSizeChange="handleSizeChange"
          @handleCurrentChange="handleCurrentChange"
        >
          <template v-slot:name="{ row }">
            <div>{{ row.name }}</div>
            <!--  芝麻企业信用认证 ali_certify_status 大于3时才显示图标 -->
            <div
              v-if="row.ali_certify_status > 3"
              style="display: flex; align-items: center"
            >
              <el-image
                style="width: 15px; height: 15px"
                fit="cover"
                :src="require('@/assets/img/zmxy.png')"
              ></el-image>
              <span style="font-size: 12px">芝麻企业信用认证</span>
            </div>
          </template>
          <template v-slot:device_type="{ row }">
            {{
              {
                1: "小程序",
                2: "ios",
                3: "安卓",
                4: "支付宝小程序",
                5: "支付宝lot设置",
                6: "web端",
              }[row.device_type] || ""
            }}
          </template>
          <template v-slot:action="{ row }">
            <el-button type="text" size="mini" @click="showDetail(row)"
              >查看</el-button
            >
          </template>
        </VTable>
      </template>
      <!-- 2.企业列表 5.下架企业 -->
      <template
        v-if="this.table.params.type === 2 || this.table.params.type === 5"
      >
        <VTable
          ref="tableDom"
          has-pagionation
          title=""
          addText="添加"
          :tableKey="table.params.type"
          :field="field2"
          :loading="table.loading"
          :data="table.data"
          :page="table.params.page"
          :pageSize="table.params.count"
          :total="table.total"
          :showSelect="table.params.type === 2"
          :selectable="() => true"
          :tree-props="{ children: 'children', hasChildren: 'has_child' }"
          :hasPagionation="true"
          :default-expand-all="true"
          :showOverflowTooltip="true"
          @handleSelectionChange="handleSelectionChange"
          @handleSizeChange="handleSizeChange"
          @handleCurrentChange="handleCurrentChange"
        >
          <template v-slot:contacter_name="{ row, $index }">
            <el-popover
              :ref="`popoverDom+${$index}`"
              placement="top"
              width="300"
              @show="handlePopovercontacter_name(row, $index)"
              @hide="handlePopovercontacter_nameHide(row, $index)"
              trigger="click"
            >
              <el-form class="staff-from" :model="editForm">
                <el-form-item label="修改对接人" prop="contacter">
                  <el-select
                    v-model="editForm.contacter"
                    filterable
                    clearable
                    placeholder="请选择"
                  >
                    <el-option
                      :label="item.name"
                      :value="item.id"
                      :key="item.id"
                      v-for="item in contacterOption"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-form>
              <el-row type="flex" justify="center">
                <el-button
                  type="primary"
                  :loading="editForm.loading"
                  :disabled="editForm.loading"
                  @click="handleContacter(row, $index)"
                  >确定</el-button
                >
              </el-row>
              <template #reference>
                <el-button type="text" icon="el-icon-edit">{{
                  row.contacter_name
                }}</el-button>
              </template>
            </el-popover>
          </template>
          <template v-slot:name="{ row }">
            <div>
              {{ row.name }}
              <el-button type="text" v-if="row.is_excellent == 1">{{
                row.is_excellent == 1 ? "优" : ""
              }}</el-button>
            </div>
            <!--  芝麻企业信用认证 ali_certify_status 大于3时才显示图标 -->
            <div
              v-if="row.ali_certify_status == 3 || row.ali_certify_status == 4"
              style="display: flex; align-items: center"
            >
              <el-image
                style="width: 15px; height: 15px"
                fit="cover"
                :src="require('@/assets/img/zmxy.png')"
              ></el-image>
              <span style="font-size: 12px">芝麻企业信用认证</span>
            </div>
            <div style="display: flex">
              <div style="color: #e6a23c">{{ row.tag_str }}</div>
              <div style="color: #67c23a; margin-left: 4px">
                {{ row.financing_type_str }}
              </div>
            </div>
          </template>
          <template v-slot:device_type="{ row }">
            {{
              {
                1: "小程序",
                2: "ios",
                3: "安卓",
                4: "支付宝小程序",
                5: "支付宝lot设置",
                6: "web端",
              }[row.device_type] || ""
            }}
          </template>
          <template v-slot:action="{ row }">
            <el-button
              v-if="row.type === '2' || row.type === '5'"
              type="text"
              size="mini"
              @click="pushPage(row, 1)"
              >招聘岗位</el-button
            >

            <el-button
              v-if="row.type === '2' || row.type === '5'"
              type="text"
              size="mini"
              @click="showDetail(row)"
              >查看</el-button
            >
            <el-dropdown>
              <span class="el-dropdown-link">
                更多<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  ><el-button
                    v-if="row.type === '2' || row.type === '5'"
                    type="text"
                    size="mini"
                    @click="pushPage(row, 2)"
                    >账户信息</el-button
                  ></el-dropdown-item
                >
                <el-dropdown-item
                  ><el-button
                    v-if="row.type === '2' || row.type === '5'"
                    type="text"
                    size="mini"
                    @click="handleFreeze(row, row.type)"
                    >{{ row.type === "2" ? "下架企业" : "上架企业" }}</el-button
                  ></el-dropdown-item
                >
                <el-dropdown-item
                  ><el-button @click="setTag(row)" type="text" size="mini">{{
                    row.tag_id ? "修改标签" : "设置标签"
                  }}</el-button></el-dropdown-item
                >
                <el-dropdown-item
                  ><el-button
                    v-if="row.type === '2' || row.type === '5'"
                    type="text"
                    size="mini"
                    @click="handleExcellent(row, row.is_excellent)"
                    >{{
                      row.is_excellent === 2 ? "设为白名单" : "取消白名单"
                    }}</el-button
                  ></el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </VTable>
      </template>
      <!-- 6.待完善 -->
      <template v-if="this.table.params.type === 6">
        <VTable
          ref="tableDom"
          has-pagionation
          title=""
          addText="添加"
          :tableKey="table.params.type"
          :field="field3"
          :loading="table.loading"
          :data="table.data"
          :page="table.params.page"
          :pageSize="table.params.count"
          :total="table.total"
          :tree-props="{ children: 'children', hasChildren: 'has_child' }"
          :hasPagionation="true"
          :default-expand-all="true"
          :showOverflowTooltip="true"
          @handleSizeChange="handleSizeChange"
          @handleCurrentChange="handleCurrentChange"
        >
          <template v-slot:device_type="{ row }">
            {{
              {
                1: "小程序",
                2: "ios",
                3: "安卓",
                4: "支付宝小程序",
                5: "支付宝lot设置",
                6: "web端",
              }[row.device_type] || ""
            }}
          </template>
          <!-- <template v-slot:action="{ row }">
            <el-button
              type="text"
              size="mini"
              icon="el-icon-delete"
              class="delBtn"
              @click="handleDetele(row)"
              >删除</el-button
            >
          </template> -->
        </VTable>
      </template>
    </div>
    <detail ref="detail" @refresh="refresh"></detail>
    <setTagDialog ref="setTagDialogRef" @refresh="getTable"></setTagDialog>
    <!-- 导入 -->
    <el-dialog
      title="导入企业"
      :visible.sync="dialogVisible"
      width="460px"
      :before-close="handleClose"
    >
      <el-form :model="form" ref="elFormDom" label-position="top">
        <el-form-item>
          <el-button type="primary" plain @click="downloadImportFile"
            >下载样表</el-button
          >
        </el-form-item>

        <el-form-item label="上传文件">
          <el-upload
            class="upload-demo"
            drag
            :limit="1"
            action=""
            :headers="{ token: token }"
            :file-list="fileList"
            :on-remove="removeFile"
            :multiple="false"
            :http-request="httpRequestBack"
            accept=".xls,.xlsx"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              将文件拖到此处，或<em>点击上传</em>
            </div>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="uploadSubmit" :loading="form.loading"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <!-- 导入异常弹窗 -->
    <el-dialog
      title="导入企业反馈信息"
      :visible.sync="errorDialogVisible"
      width="500px"
      center
      :before-close="errorClose"
    >
      <div style="font-weight: bold">
        导入成功：{{ templateDialog.success }} 条
      </div>
      <div v-if="templateDialog.errors.length > 0" class="errorBox">
        <p v-for="(item, index) in templateDialog.errors" :key="index">
          {{ index + 1 }}、{{ item }}
        </p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="errorClose">关闭</el-button>
      </span>
    </el-dialog>
    <addCompany ref="addCompanyRef" @refresh="getTable"></addCompany>
  </div>
</template>

<script>
import VTable from "@/components/VTable";
import Detail from "./components/Detail.vue";
import setTagDialog from "./components/setTagDialog.vue";
import { setStorage, getStorage } from "@/storage/index.js";
import { mixinTable } from "@/mixins/table.js";
import addCompany from "./components/addCompany.vue";
export default {
  name: "CompanyList",
  mixins: [mixinTable],
  components: {
    VTable,
    Detail,
    setTagDialog,
    addCompany
  },
  data() {
    return {
      token: getStorage("token"),
      field0: [
        { name: "name", label: "企业名称", width: "180", hidden: false },
        { name: "industry_name", label: "行业类型", hidden: false },
        { name: "legal", label: "负责人", width: "100", hidden: false },
        { name: "phone", label: "注册账号", hidden: false },
        { name: "create_time", label: "注册日期", hidden: false },
        { name: "job_num", label: "岗位数量", hidden: false },
        { name: "invite_agent_account_name", label: "邀请人", hidden: false },
        { name: "device_type", label: "来源", hidden: false },
        { name: "commit_at", label: "提交时间", hidden: false },
        {
          name: "action",
          label: "操作",
          width: "120",
          hidden: false,
          fixed: "right",
        },
      ],
      field: [
        { name: "name", label: "企业名称", width: "180", hidden: false },
        { name: "industry_name", label: "行业类型", hidden: false },
        { name: "legal", label: "负责人", width: "100", hidden: false },
        { name: "phone", label: "注册账号", hidden: false },
        { name: "create_time", label: "注册日期", hidden: false },
        { name: "job_num", label: "岗位数量", hidden: false },
        
        { name: "commit_at", label: "提交时间", hidden: false },
        { name: "reject_at", label: "审核时间", hidden: false },
        { name: "earnest_time", label: "激活日期", hidden: false },
        { name: "invite_agent_account_name", label: "邀请人", hidden: false },
        { name: "device_type", label: "来源", hidden: false },
        {
          name: "action",
          label: "操作",
          width: "120",
          hidden: false,
          fixed: "right",
        },
      ],
      field2: [
        { name: "name", label: "企业名称", width: "180", hidden: false },
        { name: "industry_name", label: "行业类型", hidden: false },
        { name: "legal", label: "负责人", width: "100", hidden: false },
        { name: "phone", label: "注册账号", hidden: false },
        { name: "create_time", label: "注册日期", hidden: false, width: "160" },
        { name: "job_num", label: "岗位数量", hidden: false },
        { name: "commit_at", label: "提交时间", hidden: false, width: "160" },
        { name: "pass_at", label: "审核时间", hidden: false, width: "160" },
        {
          name: "earnest_time",
          label: "激活日期",
          hidden: false,
          width: "160",
        },
        {
          name: "contacter_name",
          label: "对接人",
          hidden: false,
          width: "160",
        },
        { name: "invite_agent_account_name", label: "邀请人", hidden: false },
        { name: "device_type", label: "来源", hidden: false },
        {
          name: "action",
          label: "操作",
          width: "180",
          hidden: false,
          fixed: "right",
        },
      ],
      field3: [
        { name: "phone", label: "注册账号", hidden: false },
        { name: "create_time", label: "注册日期", hidden: false },
        { name: "job_num", label: "岗位数量", hidden: false },
        { name: "commit_at", label: "提交时间", hidden: false },
        { name: "pass_at", label: "审核时间", hidden: false },
        { name: "earnest_time", label: "激活日期", hidden: false },
        { name: "invite_agent_account_name", label: "邀请人", hidden: false },
        { name: "device_type", label: "来源", hidden: false },
        {
          name: "action",
          label: "操作",
          width: "120",
          hidden: false,
          fixed: "right",
        },
      ],
      table: {
        loading: false,
        params: {
          keyword: "",
          date: [],
          is_earnest: "",
          is_excellent: "",
          contacter: "",
          type: getStorage("companyStatus") || 1, // 类型 1:待审核 2:已激活 3:未充值 4:审核失败 5:下架企业 6:待完善
          page: 1,
          count: 10,
        },
        data: [],
        total: 0,
      },
      form: {
        loading: false,
        data: {
          curfile: "",
        },
      },
      fileList: [],
      dialogVisible: false,
      // 导入后提示
      errorDialogVisible: false, // 导入异常弹窗
      templateDialog: {
        success: 0,
        errors: [],
      },
      editForm: {
        contacter: "",
        loading: false,
      },
      contacterOption: [],
      selected:[],
    };
  },
  created() {
    this.getTable();
    this.getContacterOption();
  },
  methods: {
    handleSelectionChange(val) {
      this.selected = val;
    },
    recruitmentCompany() {
      if(this.selected.length){
        let dom = this.$refs.addCompanyRef;
        dom.toggle(true);
        dom.getDetail(this.selected);
      }else {
        this.$message.warning("请选择企业！");
      }
    },
    reset() {
      this.$refs.elFormDom.resetFields();
      this.table.params.page = 1;
      this.getTable();
    },
    getTable() {
      this.table.data = [];
      this.selected = [];
      let params_ = {
        ...this.table.params,
        earnest_time: this.table.params.date
          ? this.table.params.date.join("|")
          : "",
      };
      delete params_.date;
      this.$http.get("/admin/company/list", { params: params_ }).then((res) => {
        if (res.code === 1) {
          this.table.data = res.data.list;
          this.table.total = res.data.total;
          this.$nextTick(() => {
            this.$refs.tableDom.$refs.multipleTable.doLayout();
          });
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 切换状态
    handleTabs(value) {
      this.table.params.page = 1;
      this.table.params.date = [];
      this.table.params.is_earnest = "";
      this.table.params.is_excellent = "";
      this.table.data = [];
      setStorage("companyStatus", value);
      this.getTable();
    },
    //  2下架、5上架
    handleFreeze(row, type) {
      console.log(type);
      let str = type === "2" ? "下架" : "上架";
      let _params = {
        id: row.id,
        type: type,
      };
      this.$confirm(`请确认是否${str}该企业？`, "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
      })
        .then(() => {
          this.$http.post("/admin/company/operation", _params).then((res) => {
            if (res.code === 1) {
              this.$message.success("操作成功！");
              this.getTable();
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => {});
    },
    handleExcellent(row, type) {
      console.log(type);
      let str =
        type === 2
          ? "加入白名单用户将不受保证金额度限制，确定要设为白名单吗？"
          : "取消白名单？";
      let _params = {
        id: row.id,
        is_excellent: { 1: 2, 2: 1 }[type],
      };
      this.$confirm(str, "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
      })
        .then(() => {
          this.$http
            .post("/admin/company/operateExcellent", _params)
            .then((res) => {
              if (res.code === 1) {
                this.$message.success("操作成功！");
                this.getTable();
              } else {
                this.$message.error(res.msg);
              }
            });
        })
        .catch(() => {});
    },
    // 操作记录 type:1招聘岗位、2.账号信息
    pushPage(row, type) {
      sessionStorage.setItem("companyId", row.id);
      let _url = type === 1 ? "/quarters" : "/account";
      this.$router.push({
        path: _url,
        query: {
          companyName: row.name,
        },
      });
    },
    // 审核
    showDetail(row) {
      let dom = this.$refs.detail;
      dom.toggle(true);
      dom.getDetail(row);
      dom = null;
    },

    // 删除
    handleDetele(row) {
      console.log(row);
    },
    refresh(status) {
      this.table.params.status === status;
      this.getTable();
    },
    removeFile() {
      this.fileList = [];
    },
    httpRequestBack(file) {
      this.form.curfile = file.file;
    },
    uploadSubmit() {
      this.$refs.elFormDom.validate((valid) => {
        if (valid) {
          if (this.form.curfile) {
            let formData = new FormData();
            formData.append("file", this.form.curfile);
            this.form.loading = true;
            this.$http
              .post("/admin/company/import", { formData, type: "upload" })
              .then((res) => {
                if (res.code == 1) {
                  this.errorDialogVisible = true;
                  this.templateDialog.errors = res.data.errors;
                  this.templateDialog.success = res.data.success;
                }
              })
              .finally(() => {
                this.form.loading = false;
                this.handleClose();
              });
          } else {
            this.$message.warning("请选择要导入的文件");
          }
        }
      });
    },
    // 关闭导入弹窗
    handleClose() {
      this.dialogVisible = false;
      this.fileList = [];
      this.form.curfile = [];
    },
    // 关闭异常
    errorClose() {
      this.errorDialogVisible = false;
      this.getTable();
    },
    downloadImportFile() {
      window.open(
        process.env.VUE_APP_BASE_API +
          "/admin/company/downloadImportFile?token=" +
          this.token
      );
    },
    getContacterOption() {
      let params = {
        page: 1,
        count: 9999,
      };
      this.$http.get("/admin/admin/list", { params: params }).then((res) => {
        if (res.code === 1) {
          this.contacterOption = res.data.list;
        }
      });
    },
    handlePopovercontacter_name(row) {
      this.getContacterOption();
      this.editForm.contacter = row.contacter || "";
    },
    handlePopovercontacter_nameHide() {
      this.editForm.contacter = "";
    },
    handleContacter(row) {
      if (this.editForm.contacter === "") {
        this.$message.warning("请选择");
        return;
      }
      this.editForm.loading = true;
      let params = {
        contacter: this.editForm.contacter,
        id: row.id,
      };
      this.$http
        .post("/admin/company/setContacter", params)
        .then((res) => {
          if (res.code === 1) {
            this.$message.success("操作成功！");
            this.getTable();
          }
        })
        .finally(() => {
          this.editForm.loading = false;
          this.handlePopovercontacter_nameHide();
        });
    },
    setTag(row) {
      let dom = this.$refs.setTagDialogRef;
      dom.toggle(true);
      dom.getDetail(row);
      dom = null;
    },
  },
};
</script>

<style scoped lang="scss">
.flex {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
.proposal__wrap {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 20px;
  position: relative;

  .filter__wrap {
    padding: 10px;
    margin-bottom: 20px;
    // display: flex;
    // justify-content: space-between;
  }

  .table__wrap {
    flex: 1;
    padding: 0;
    box-sizing: border-box;
  }
}
.el-dropdown-link {
  cursor: pointer;
  color: #30c3b1;
  font-size: 12px;
  margin: 0 0 0 10px;
}
.el-icon-arrow-down {
  font-size: 12px;
}
</style>